import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=2058db8b&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=2058db8b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2058db8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2058db8b')) {
      api.createRecord('2058db8b', component.options)
    } else {
      api.reload('2058db8b', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=2058db8b&scoped=true&", function () {
      api.rerender('2058db8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vwO1T0MersFh/JS/comp/PopupDialog.vue"
export default component.exports